import Skeleton from "@mui/material/Skeleton";
import React, { FC } from "react";

export const MetadataTagDetailsSkeleton: FC = () => (
  <Skeleton
    sx={{
      height: 204,
      borderRadius: "1rem",
      transform: "none",
      marginBottom: "1rem",
    }}
  />
);

export default MetadataTagDetailsSkeleton;
